import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "reduce",
  "use": "reduce-usage",
  "viewBox": "0 0 146 146",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 146 146\" id=\"reduce\">\n<style type=\"text/css\">\n\t#reduce .st0{fill-rule:evenodd;clip-rule:evenodd;}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M73,0C32.7,0,0,32.7,0,73c0,40.3,32.7,73,73,73c40.3,0,73-32.7,73-73C146,32.7,113.3,0,73,0z M73,136.9\n\t\tc-35.3,0-63.9-28.6-63.9-63.9C9.1,37.7,37.7,9.1,73,9.1c35.3,0,63.9,28.6,63.9,63.9C136.9,108.3,108.3,136.9,73,136.9z\" />\n\t<path class=\"st0\" d=\"M119.5,79.6H26.5c-3.7,0-6.6-3-6.6-6.6v0c0-3.7,3-6.6,6.6-6.6h92.9c3.7,0,6.6,3,6.6,6.6v0\n\t\tC126.1,76.7,123.1,79.6,119.5,79.6z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/reduce.svg
// module id = bjWj
// module chunks = 268